import template from './liveFeedVideo.html';
import controller from './liveFeedVideo.controller';
import './liveFeedVideo.scss';

export default {
  restrict: 'E',
  bindings: {
    feedConfig: '<', // This will take a config object with something like {feedUrl: 'http://...', size:'large'}
    onSelect: '&',
    onReady: '&',
    enlargeKeydown: '&'
  },
  template,
  controller,
  controllerAs: 'vm'
};



/** WEBPACK FOOTER **
 ** ./client/app/components/common/liveFeedVideo/liveFeedVideo.component.js
 **/